import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formErrors',
    standalone: false,
})
export default class FormErrorsPipe implements PipeTransform {
    /**
     *
     */
    transform(errors: { [k: string]: string }): string {
        if (!errors) {
            return '';
        }

        return this.setErrors(errors);
    }

    /**
     *
     */

    /**
     *
     */
    private setErrors(errorsObj: { [k: string]: string }): string {
        for (const key of Object.keys(errorsObj)) {
            if (typeof errorsObj[key] === 'string') {
                return errorsObj[key];
            }
        }
        return '';
    }
}
